import React from "react";
import Left from "../components/left";

import Navbar from "../components/Navbar";

const Home = () => {
    return (
        <div>
            <Navbar />
            <Left />
        </div>
    );
};

export default Home;
